import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {AgreementClause, GROUP_TYPES, Participant} from '@guestapp/sdk';

export type GuestsData = {
  contract_email?: string;
  send_copy_contract_email?: boolean;
  agreement_clauses?: AgreementClause[];
};
export interface OnboardingState {
  leaderGuestId: string | null;
  groupType?: GROUP_TYPES;
  participants: Participant[];
  guestsData: GuestsData;
}

interface OnboardingStore extends OnboardingState {
  setLeaderGuestId: (id: string) => void;
  setGroupType: (groupType: GROUP_TYPES) => void;
  setParticipants: (participants: Participant[]) => void;
  setGuestsData: (guestsData: GuestsData) => void;
  updateState: (guestsData: Partial<OnboardingState>) => void;
  resetState: () => void;
}

const INITIAL_STATE: OnboardingState = {
  leaderGuestId: null,
  participants: [],
  guestsData: {},
};

export const useOnboardingStore = create<OnboardingStore>()(
  persist(
    set => ({
      ...INITIAL_STATE,
      setLeaderGuestId: leaderGuestId => set({leaderGuestId}),
      setGroupType: groupType => set({groupType}),
      setParticipants: participants => set({participants}),
      setGuestsData: guestsData => set({guestsData}),
      updateState: guestsData => set(guestsData),

      resetState: () => set(INITIAL_STATE),
    }),
    {
      name: 'onboarding-store',
      partialize: state => ({
        participants: state.participants,
      }),
    },
  ),
);
